// We currently do not need to pass any information to the endpint
export default class SignupCheckoutRequest {
}